import { createContext } from 'preact-compat'
import { page404WithoutContext } from './page404WithoutContext'
import { PageContextWithURL } from './types'

export const CurrentPageContext = createContext<PageContextWithURL>({
  ...page404WithoutContext,
  fullUrl: new URL('http://127.0.0.1/404')
})
